import axios from "axios";
import { useAuth } from "../Context/authContext";

const endpoints = {
  profile: "/profile",
};

export const getProfile = async () => {
  const token = localStorage.getItem("token");
  const url = new URL(window.location.href);
  const subdomain = url.hostname.split(".")[0] || "doctor";

  if (!token) {
    console.error("Token not found");
    return null;
  }
  try {
    const response = await axios.get(`${endpoints.profile}/${subdomain}`, {});
    return response.data;
  } catch (error) {
    console.error("Error fetching profile:", error);
    return null;
  }
};
